module.exports = __webpack_public_path__ + "d87a9ca64f8791cb135145f3e8dbca6c.svg";